// js script to be put in <head> tag in case js is rendered in php
// DON'T USE JQUERY IN THIS FILE SO WE CAN KEEP THIS FILE IN THE <head> AND JQUERY IN THE FOOTER
(function(gtmHelper, undefined) {
	/**
	 * Pass an event to a Janus Henderson API for processing.
	 *
	 * @param eventData Object containing event information.
	 */

	// Bind to Qumu JS Widget player events via API
	gtmHelper.bindQumuEvents = function(api) {
		api.bind(
			'play',
			function() {
				api.get(
					'currentTime',
					function(currentTime) {
						recordQumuEvent( api, currentTime, 'play' );
					}
				);
			}
		);

		api.bind(
			'pause',
			function(time) {
				api.get(
					'currentTime',
					function(currentTime) {
						recordQumuEvent( api, currentTime, 'pause' );
					}
				);
			}
		);

		api.bind(
			'ended',
			function(time) {
				api.get(
					'currentTime',
					function(currentTime) {
						recordQumuEvent( api, currentTime, 'ended' );
					}
				);
			}
		);
	};

	// Bind to Qumu iframe player events via API
	gtmHelper.bindQumuIframeEvents = function(api) {
		api.bind(
			'play',
			function() {
				api.get(
					'currentTime',
					function(currentTime) {
						recordQumuIframeEvent( api, currentTime, 'play' );
					}
				);
			}
		);

		api.bind(
			'pause',
			function() {
				api.get(
					'currentTime',
					function(currentTime) {
						recordQumuIframeEvent( api, currentTime, 'pause' );
					}
				);
			}
		);

		api.bind(
			'ended',
			function() {
				api.get(
					'currentTime',
					function(currentTime) {
						recordQumuIframeEvent( api, currentTime, 'ended' );
					}
				);
			}
		);
	}

	/*
	 Record Qumu player events for iframe implementation
	 event qumu-video
	 video.action One of; play, pause or ended.
	 video.time The current time of the video playing within the Qumu widget.
	 video.title The title of the video being played, pulled from the Qumu API.
	 */
	function recordQumuIframeEvent(api, currentTime, action) {
		var title = api.iframe();

		//console.log(time + " " + action + " " + title); // For debugging
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(
			{
				'event': 'qumu-video',
				'video': {
					'action': action,
					'title': title,
					'time': millisToMinutesAndSeconds( currentTime )
				}
			}
		);
	}

	function millisToMinutesAndSeconds(millis) {
		if (millis == 0) {
			return '00:00';
		}
		var minutes = Math.floor( millis / 60000 );
		var seconds = ((millis % 60000) / 1000).toFixed( 0 );
		if (seconds == 60) {
			seconds = 0
			minutes++;
		}
		return (minutes < 10 ? '0' : '') + minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
	}

	/*
	 Record Qumu player events for JS widget implementation
	 event qumu-video
	 video.action One of; play, pause or ended.
	 video.time The current time of the video playing within the Qumu widget.
	 video.title The title of the video being played, pulled from the Qumu API.
	 */
	function recordQumuEvent(api, currentTime, action) {
		var title, duration;

		api.get(
			'kulu',
			function(kulu) {
				title    = kulu.title;
				duration = kulu.duration;
			}
		);

		// Qumu player sends 2x pause events when video ends – avoid them.
		if (action == "pause" && currentTime >= duration) {
			return;
		}

		//console.log(time + " " + action + " " + title); // For debugging
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(
			{
				'event': 'qumu-video',
				'video': {
					'action': action,
					'title': title,
					'time': millisToMinutesAndSeconds( currentTime )
				}
			}
		);
	}

	/*
	 Record user login events
	 login-register.status Either; Success or Failure – identifies whether the login was completed successfully or not.
	 login-register.message For login failures only - the message that identifies the failure reason.
	 userMeta.userId The internal user-id for the successfully logged in user.
	 */
	gtmHelper.recordLogin = function(status, subscriber, failureMessage) {
		var failureMessage = failureMessage || undefined;
		var userId         = undefined;
		if (subscriber != null) {
			userId = subscriber.scrambledId;
		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(
			{
				'event' : 'user-login',
				'login-register' : {
					'status' : status,
					'message' : failureMessage
				},
				'userMeta' : {
					'userId' : userId
				}
			}
		);
	};

	/*
	 Record user registration events
	 login-register.status Either; Success or Failure – identifies whether the login was completed successfully or not.
	 login-register.message For login failures only - the message that identifies the failure reason.
	 userMeta.userId The internal user-id for the successfully logged in user.
	 */
	gtmHelper.recordRegistration = function(status, subscriber, failureMessage) {
		var failureMessage = failureMessage || undefined;
		var userId         = undefined;
		if (subscriber != null) {
			userId = subscriber.scrambledId;
		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(
			{
				'event' : 'user-registration',
				'registration' : {
					'status' : status,
					'message' : failureMessage
				},
				'userMeta' : {
					'userId' : userId
				}
			}
		);
	};

	// Get cookie by name
	function getCookie(name) {
		var value = "; " + document.cookie;
		var parts = value.split( "; " + name + "=" );
		if (parts.length == 2) {
			return parts.pop().split( ";" ).shift();
		}
	}

	/**
	 * @deprecated This seems to be only used on EN-US and not implemented on GWP. Leaving in for now.
	 *
	 * Get subject matter
	 * subjectMatter retrieves only a portion of the GTM variable pageMeta.pageType which comes in this format, page-label::catagory/subcatagory
	 * only return one of page-label, category, or subcategory
	 */
	function getSubjectMatter() {
		// var subjectMatter = $( 'body' ).attr( 'data-gtm-page-type' ) || ""; //TODO: CAN'T USE JQUERY IN THIS FILE
		// if (subjectMatter.indexOf( "::" ) >= 0 && subjectMatter.split( "::" ).length > 1) {
		// 	// return category
		// 	subjectMatter = subjectMatter.split( "::" ).slice( -1 ).pop();
		// 	if (subjectMatter.indexOf( "/" ) >= 0 && subjectMatter.split( "/" ).length > 1) {
		// 		// return subcategory
		// 		subjectMatter = subjectMatter.split( "/" ).slice( -1 ).pop();
		// 	}
		// }
		// return subjectMatter.trim();
		return false;
	}

	/*
	 Extract subject
	 subject is the HTML title which a labeled like bread crumbs delimited by '|'
	 only return the first title
	 */
	function extractSubject(subject) {
		if (subject.indexOf( '|' ) >= 0 && subject.split( "|" ).length > 1) {
			subject = subject.split( "|" )[0];
		}
		return subject.trim();
	}

})( window.gtmHelper = window.gtmHelper || {} );


/**
 * Needs to be loaded at top
 * Lodash alternatives helper function enqueue
 * Custom script to load before gwp-child-theme 
 */
var jh_custom = {};
( function($) { 

	// Vanilla Debounce
	var _debounce = function(func, wait) {
		var timeout;

		return function executedFunction(args) {
			var later = function () {
				clearTimeout(timeout);
				func(args);
			};

			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}; 
	jh_custom.debounce = _debounce;
	
})( jQuery );